function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 10.6665C114.56 10.6665 -7.62939e-06 123.307 -7.62939e-06 262.229C-7.62939e-06 373.397 73.344 467.669 175.04 500.906C187.84 503.274 192.533 495.488 192.533 488.811C192.533 482.837 192.32 467.008 192.213 446.037C121.003 461.205 105.984 412.288 105.984 412.288C94.336 383.253 77.504 375.488 77.504 375.488C54.3147 359.893 79.296 360.213 79.296 360.213C105.003 361.963 118.507 386.133 118.507 386.133C141.333 424.597 178.432 413.482 193.067 407.061C195.371 390.784 201.963 379.712 209.28 373.419C152.427 367.125 92.672 345.493 92.672 249.109C92.672 221.653 102.592 199.211 119.019 181.611C116.139 175.253 107.499 149.675 121.259 115.029C121.259 115.029 142.699 108.288 191.659 140.821C212.139 135.232 233.899 132.459 255.659 132.331C277.419 132.459 299.179 135.232 319.659 140.821C368.299 108.288 389.739 115.029 389.739 115.029C403.499 149.675 394.859 175.253 392.299 181.611C408.619 199.211 418.539 221.653 418.539 249.109C418.539 345.749 358.699 367.019 301.739 373.205C310.699 380.757 319.019 396.181 319.019 419.755C319.019 453.419 318.699 480.469 318.699 488.64C318.699 495.232 323.179 503.104 336.299 500.587C438.72 467.563 512 373.227 512 262.229C512 123.307 397.376 10.6665 256 10.6665V10.6665Z",
  fill: "#7D76A5"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512,
  fill: "white"
})));

var SvgGithub = function SvgGithub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGithub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/github.4f513d7c.svg";
export { ForwardRef as ReactComponent };